import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Audience from '../../pages/difacto/audiences/Audience';
import AudiencesList from '../../pages/difacto/audiences/AudiencesList';
import NewAudience from "../../pages/difacto/audiences/NewAudience";
import EditAudience from "../../pages/difacto/audiences/EditAudience";

function Audiences(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={AudiencesList}/>
        <Route exact path={`${path}/new`} component={NewAudience}/>
        <Route path={`${path}/:audienceId/edit`} component={EditAudience}/>
        <Route path={`${path}/:audienceId`} component={Audience}/>
      </Switch>
    </Suspense>
  )
}

export default Audiences
